import { DeliveryData } from "../receivers/deliveryTypes/DeliveryData";
import FaceDeliveryData from "../receivers/deliveryTypes/faceReceiver/FaceDeliveryData";

export function isFaceDeliveryData(
  deliveryData: DeliveryData
): deliveryData is FaceDeliveryData {
  return deliveryData !== null && "managingBody" in deliveryData;
}
